import { connect } from 'react-redux';

import { closeSmallDrawer } from 'actions/smallDrawer';
import { openPreview } from 'actions/preview';
import { openModal } from 'actions/modal';
import { getCurrentUserIdSelector } from 'selectors/user';
import { FEED_DRAWER_GALLERY } from 'types/smallDrawer';
import { MODAL_DELETE_FEEDITEM } from 'types/modal';
import  { actions, selectors } from '@amplement/backend-connector';

import GalleryDrawerBasic from './index';

const mapStateToProps = (state, { _feed }) => ({
    items: selectors.feedItems.getFileFeedItemsByFeedSelector(state, _feed),
    isLoading: false,
    _feed,
    _currentUser: getCurrentUserIdSelector(state)
});

const mapDispatchToProps = (dispatch, { _feed }) => ({
    onClose: () => dispatch(closeSmallDrawer(FEED_DRAWER_GALLERY)),
    onFilePreview: _feedItem => dispatch(openPreview(_feedItem)),
    getFiles: () => dispatch(actions.feedItems.requestGetFeedItemFiles(_feed)),
    deleteFeedItem: (_feedItem, content) => dispatch(
        openModal(MODAL_DELETE_FEEDITEM, { _feed, _feedItem, content })
    )
});

export default connect(mapStateToProps, mapDispatchToProps)(GalleryDrawerBasic);
